import { randomInt, stringToSeed } from "../core/random.js";

export const RUN_UNIT_NAME_MAX_LENGTH = 24;

export const RUN_UNIT_NAME_POOLS = Object.freeze({
  grunt: Object.freeze([
    "Mara",
    "Deke",
    "Inez",
    "Cal",
    "Tessa",
    "Holt",
    "Nia",
    "Bram",
    "Vera",
    "Juno",
    "Pike",
    "Lena",
    "Mack",
    "Oren",
    "Rue",
    "Kellan",
    "Mina",
    "Tuck",
    "Anya",
    "Boone",
    "Cass",
    "Dax",
    "Elia",
    "Flint",
    "Gwen",
    "Hale",
    "Ivo",
    "Jax",
    "Kit",
    "Lux",
    "Milo",
    "Nell",
    "Orin",
    "Pax",
    "Quinn",
    "Remy",
    "Shay",
    "Vale",
  ]),
  breaker: Object.freeze([
    "Brick",
    "Knuckles",
    "Mallet",
    "Rivet",
    "Sledge",
    "Torque",
    "Anvil",
    "Bishop",
    "Crank",
    "Diesel",
    "Hammer",
    "Ire",
    "Jolt",
    "Kilo",
    "Latch",
    "Mox",
    "Nails",
    "Ox",
    "Piston",
    "Quarry",
    "Ram",
    "Scar",
    "Talon",
    "Ursula",
    "Vice",
    "Weld",
    "Yardarm",
    "Zed",
    "Boulder",
    "Chisel",
    "Dozer",
    "Forge",
    "Grit",
    "Havoc",
    "Iron",
    "Knockout",
    "Maul",
    "Rasp",
    "Tremor",
  ]),
  longshot: Object.freeze([
    "Aster",
    "Blink",
    "Crosshair",
    "Dove",
    "Eagle",
    "Faraday",
    "Glass",
    "Hush",
    "Ibis",
    "Kestrel",
    "Lark",
    "Mercy",
    "Needle",
    "Osprey",
    "Pin",
    "Quiet",
    "Reed",
    "Scope",
    "Trace",
    "Vesper",
    "Wisp",
    "Yarrow",
    "Zenith",
    "Argus",
    "Beacon",
    "Cinder",
    "Drift",
    "Farsight",
    "Ghost",
    "Heron",
    "Ivory",
    "Keen",
    "Lumen",
    "North",
    "Oracle",
    "Peregrine",
    "Ranger",
    "Still",
    "Watchman",
  ]),
  medic: Object.freeze([
    "Ada",
    "Bex",
    "Clara",
    "Doc",
    "Elise",
    "Fern",
    "Galen",
    "Hope",
    "Imani",
    "Jonah",
    "Kira",
    "Lyle",
    "Mae",
    "Niko",
    "Opal",
    "Patch",
    "Rhea",
    "Sana",
    "Theo",
    "Uma",
    "Vita",
    "Wren",
    "Yara",
    "Zuri",
    "Ames",
    "Briar",
    "Cora",
    "Dorian",
    "Ember",
    "Florence",
    "Grace",
    "Harbor",
    "Iris",
    "Jules",
    "Kindle",
    "Linden",
    "Mender",
    "Nightingale",
    "Remedy",
    "Solace",
  ]),
  mechanic: Object.freeze([
    "Axle",
    "Bender",
    "Clutch",
    "Dinah",
    "Eddie",
    "Fixer",
    "Grease",
    "Hex",
    "Izzy",
    "Jack",
    "Kip",
    "Lathe",
    "Mags",
    "Nut",
    "Oiler",
    "Plug",
    "Ratchet",
    "Socket",
    "Tinker",
    "Vise",
    "Washer",
    "Yoke",
    "Zip",
    "Bearing",
    "Cam",
    "Drill",
    "Gauge",
    "Hob",
    "Jig",
    "Key",
    "Lug",
    "Miller",
    "Patchcord",
    "Relay",
    "Sprocket",
    "Tap",
    "Wrench",
    "Arc",
    "Coil",
    "Sparks",
  ]),
  runner: Object.freeze([
    "Backfire",
    "Blue Streak",
    "Comet",
    "Dust Devil",
    "Easy Rider",
    "Fast Track",
    "Greyhound",
    "Hotwire",
    "Impulse",
    "Jackrabbit",
    "Kilometer",
    "Lucky Seven",
    "Mercury",
    "Night Ride",
    "Overdrive",
    "Pit Cobra",
    "Quickstep",
    "Roadrunner",
    "Sidewinder",
    "Top Gear",
    "Undertow",
    "Velocity",
    "Wild Card",
    "Yellow Line",
    "Zero Hour",
    "Afterburn",
    "Burnout",
    "Crosswind",
    "Dash",
    "Express",
    "Flashpoint",
    "Green Light",
    "Highway Star",
    "Long Haul",
    "Moonrunner",
    "Outrider",
    "Redline",
    "Slipstream",
    "Tailwind",
    "Waypoint",
  ]),
  bruiser: Object.freeze([
    "Bad Company",
    "Black Dog",
    "Crowbar",
    "Deadbolt",
    "Earthshaker",
    "Fistful",
    "Grindstone",
    "Hard Case",
    "Iron Duke",
    "Jawbreaker",
    "Knockdown",
    "Last Word",
    "Mean Streak",
    "No Quarter",
    "Old Scratch",
    "Pile Driver",
    "Roughneck",
    "Stonewall",
    "Thunderhead",
    "Uppercut",
    "Warhorse",
    "Wrecking Ball",
    "Ballast",
    "Bonecrusher",
    "Cold Iron",
    "Demolition",
    "Enforcer",
    "Freight Train",
    "Grudge",
    "Heavy Metal",
    "Ironclad",
    "Lockjaw",
    "Marauder",
    "Night Hammer",
    "Outlaw",
    "Payback",
    "Roadblock",
    "Strongarm",
    "Vendetta",
    "Warpath",
  ]),
  juggernaut: Object.freeze([
    "Armageddon",
    "Behemoth",
    "Cataclysm",
    "Dreadnought",
    "Extinction",
    "Fortress",
    "Goliath",
    "Hellbent",
    "Imperator",
    "Jugger",
    "Kraken",
    "Leviathan",
    "Monolith",
    "Nemesis",
    "Oblivion",
    "Overlord",
    "Palisade",
    "Quake",
    "Ragnarok",
    "Sovereign",
    "Titan",
    "Unbroken",
    "Vanguard",
    "Warmonger",
    "Annihilator",
    "Bastion",
    "Colossus",
    "Doomsday",
    "Endurance",
    "Fury",
    "Gravestone",
    "Hammerfall",
    "Iron Mountain",
    "Kingmaker",
    "Last Argument",
    "Mammoth",
    "Onslaught",
    "Rampart",
    "Siegebreaker",
    "World Ender",
  ]),
  "siege-gun": Object.freeze([
    "Long Thunder",
    "Bellringer",
    "Crater Maker",
    "Dead Reckoning",
    "Earthmover",
    "Fire Mission",
    "Grand Slam",
    "High Arc",
    "Iron Rain",
    "Judgment",
    "King's Ransom",
    "Longbow",
    "Meteor",
    "Noonday",
    "Ordinance",
    "Peacemaker",
    "Quartermaster",
    "Rolling Thunder",
    "Sundial",
    "Tremor",
    "Umbra",
    "Vulcan",
    "War Drum",
    "Zero Point",
    "Anvil Chorus",
    "Barrage",
    "Cannonade",
    "Deep Strike",
    "Excalibur",
    "Falling Star",
    "Groundbreaker",
    "Harbinger",
    "Impact",
    "Long Reach",
    "Mortarboard",
    "Overwatch",
    "Rainmaker",
    "Steel Tempest",
    "Thunderclap",
    "War Bell",
  ]),
  skyguard: Object.freeze([
    "Aegis",
    "Belltower",
    "Cloudbreak",
    "Domekeeper",
    "Eye Line",
    "Flak House",
    "Gatekeeper",
    "High Watch",
    "Iron Umbrella",
    "Javelin",
    "Kite Shield",
    "Lightning Rod",
    "Morning Star",
    "No Fly Zone",
    "Overcast",
    "Picket",
    "Queen's Guard",
    "Radar Love",
    "Skyhook",
    "Tripwire",
    "Updraft",
    "Vigil",
    "Watchtower",
    "Airlock",
    "Blue Shield",
    "Ceiling",
    "Dragonfly",
    "Flintlock",
    "Guardian",
    "Halo",
    "Interceptor Two",
    "Lookout",
    "North Star",
    "Open Sky",
    "Rampart",
    "Sentinel",
    "Storm Fence",
    "Tin Roof",
    "Ward",
    "Windbreak",
  ]),
  gunship: Object.freeze([
    "Angel One",
    "Blackbird",
    "Copperhead",
    "Dragon",
    "Eclipse",
    "Firefly",
    "Griffin",
    "Harpy",
    "Inferno",
    "Jackal",
    "Kodiak",
    "Lancer",
    "Manticore",
    "Night Witch",
    "Odin",
    "Phoenix",
    "Razor",
    "Specter",
    "Thunderbird",
    "Valkyrie",
    "Warlock",
    "Wyvern",
    "Bad Moon",
    "Cyclone",
    "Darkstar",
    "Fang",
    "Hellcat",
    "Iron Eagle",
    "Long Knife",
    "Marauder",
    "Nighthawk",
    "Outrider",
    "Red Angel",
    "Scorpion",
    "Tempest",
    "Viper",
    "Wildfire",
    "Wraith",
    "Zulu",
    "Raven",
  ]),
  payload: Object.freeze([
    "Big Sky",
    "Cloud Nine",
    "Deep Cargo",
    "Endeavor",
    "Freelifter",
    "Ganymede",
    "Heavy Weather",
    "Iron Caravan",
    "Jupiter",
    "Keystone",
    "Long March",
    "Mule",
    "Night Freight",
    "Olympus",
    "Packhorse",
    "Queen Bee",
    "Rookery",
    "Skybridge",
    "Titan Haul",
    "Union Jack",
    "Voyager",
    "Wayfarer",
    "Air Train",
    "Broadwing",
    "Constellation",
    "Dropship One",
    "Evergreen",
    "Flying Fortress",
    "Great Bear",
    "High Country",
    "Long Hauler",
    "Magellan",
    "Northbound",
    "Outpost",
    "Providence",
    "Sky Wagon",
    "Trailblazer",
    "Uplift",
    "Westward",
  ]),
  interceptor: Object.freeze([
    "Ace",
    "Bandit",
    "Cobra",
    "Dagger",
    "Eagle Eye",
    "Foxbat",
    "Goshawk",
    "Hornet",
    "Iceman",
    "Javelin",
    "Killer Bee",
    "Lightning",
    "Mako",
    "Nightshade",
    "Osprey",
    "Prowler",
    "Quick Silver",
    "Red Baron",
    "Sabre",
    "Talon",
    "Vector",
    "Wild Weasel",
    "Arrow",
    "Blue Max",
    "Cutlass",
    "Delta",
    "Gambit",
    "Hurricane",
    "Kite",
    "Mach One",
    "Needle",
    "Onyx",
    "Rapier",
    "Shrike",
    "Starling",
    "Tomcat",
    "Voodoo",
    "Warhawk",
    "Zero",
  ]),
});

export function normalizeRunUnitName(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

export function getRunUnitNameKey(value) {
  return normalizeRunUnitName(value).toLowerCase();
}

export function validateRunUnitName(value, excludedNames = []) {
  const name = normalizeRunUnitName(value);
  const excludedKeys = new Set(
    excludedNames.map(getRunUnitNameKey).filter(Boolean),
  );

  if (!name) {
    return { valid: false, name, error: "Enter a unit name." };
  }

  if (name.length > RUN_UNIT_NAME_MAX_LENGTH) {
    return {
      valid: false,
      name,
      error: `Use ${RUN_UNIT_NAME_MAX_LENGTH} characters or fewer.`,
    };
  }

  if (!/^[\p{L}\p{N} .'-]+$/u.test(name)) {
    return {
      valid: false,
      name,
      error: "Use letters, numbers, spaces, apostrophes, periods, or hyphens.",
    };
  }

  if (excludedKeys.has(getRunUnitNameKey(name))) {
    return {
      valid: false,
      name,
      error: "That name is already part of this run.",
    };
  }

  return { valid: true, name, error: "" };
}

function appendUniqueSuffix(baseName, suffix) {
  const suffixText = ` ${suffix}`;
  const availableLength = Math.max(
    1,
    RUN_UNIT_NAME_MAX_LENGTH - suffixText.length,
  );
  return `${baseName.slice(0, availableLength).trimEnd()}${suffixText}`;
}

export function generateRunUnitName(
  unitTypeId,
  { unitId = unitTypeId, roll = 0, excludedNames = [] } = {},
) {
  const pool = RUN_UNIT_NAME_POOLS[unitTypeId] ?? ["Ash"];
  const excludedKeys = new Set(
    excludedNames.map(getRunUnitNameKey).filter(Boolean),
  );
  const seed = stringToSeed(`${unitTypeId}:${unitId}:${roll}`);
  const startIndex = randomInt(seed, 0, pool.length - 1).value;

  for (let offset = 0; offset < pool.length; offset += 1) {
    const candidate = pool[(startIndex + offset) % pool.length];

    if (!excludedKeys.has(getRunUnitNameKey(candidate))) {
      return candidate;
    }
  }

  const baseName = pool[startIndex];
  let suffix = 2;

  while (
    excludedKeys.has(getRunUnitNameKey(appendUniqueSuffix(baseName, suffix)))
  ) {
    suffix += 1;
  }

  return appendUniqueSuffix(baseName, suffix);
}
